import { channels } from '@/mocks/channels';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function ChannelGrid() {
  return (
    <section id="channels" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          kicker="Columns"
          title="三大深挖栏目 · 每条线都追到源头"
          description="栏目不是分类标签，而是三种不同的追问方式：谁在做决定、钱怎么走、情绪如何被组织。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {channels.map((channel) => (
            <article
              key={channel.id}
              className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-300 hover:bg-background-50 md:p-7"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-foreground-950 text-background-50">
                  <i className={`${channel.icon} text-2xl`} />
                </span>
                <span className="font-heading text-sm font-bold text-foreground-500">{channel.count}</span>
              </div>
              <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                {channel.name}
              </h3>
              <p className="mt-2.5 flex-1 text-sm leading-relaxed text-foreground-600">{channel.desc}</p>
              <div className="mt-5 flex flex-wrap gap-2">
                {channel.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-secondary-100 px-3 py-1 text-[11px] text-secondary-900"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <span className="mt-6 flex items-center gap-1.5 border-t border-background-200 pt-4 text-xs font-medium text-primary-600">
                进入栏目
                <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1" />
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}